import { render, staticRenderFns } from "./BillIndex.vue?vue&type=template&id=26ee52a2&scoped=true&"
import script from "./BillIndex.vue?vue&type=script&lang=ts&"
export * from "./BillIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ee52a2",
  null
  
)

export default component.exports